// formFields.js  
export const formFields = [  
    { section: "From (Header)", name: "parDscScheduleName", label: "Schedule", fieldLabel: "Schedule", type: "text", options: { maxLength: { value: 10, message: "MAXLENGTH_10" } }, fieldNature: "Add: Read-only", position: [5, 22] },  
    { section: "From (Header)", name: "parDscDescription", label: "Description", fieldLabel: "Description", type: "text", options: { maxLength: { value: 40, message: "MAXLENGTH_40" } }, fieldNature: "Add: Read-only", position: [6, 22] },  
    { section: "To (Header)", name: "dtlDscScheduleName", label: "Schedule", fieldLabel: "Schedule", type: "text", options: { required: { value: true, message: "REQUIRED" }, maxLength: { value: 10, message: "MAXLENGTH_10" } }, fieldNature: "Add: Editable", position: [9, 22] },  
    { section: "To (Header)", name: "dtlDscDescription", label: "Description", fieldLabel: "Description", type: "text", options: { required: { value: true, message: "REQUIRED" }, maxLength: { value: 40, message: "MAXLENGTH_40" } }, fieldNature: "Add: Editable", position: [10, 22] }  
  ]; 
  // screenInfo.js  
  export const screenInfo = {  
    SCREEN_TITLE: 'Copy Out of Pocket Max Schedule',  
    SCREEN_NUMBER: 'RCOPC004',  
  };  
    
 
  